exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/everis/code/Dj/front.staff/src/app/form-requisition/form-requisition.component.css
// module id = ../../../../../src/app/form-requisition/form-requisition.component.css
// module chunks = main